import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { BackofficeService } from "../../services/backoffice.service";
import {
  closeAlertAction,
  showAlertAction,
} from "../../store/actions/alert.action";
import {
  closeLoadingAction,
  showLoadingAction,
} from "../../store/actions/loading.action";
import { IAppState } from "../../store/state/app.state";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { merge, Observable, of as observableOf } from "rxjs";
import { catchError, map, startWith, switchMap } from "rxjs/operators";
import { iconsLibrary } from "../../../theme/constants";
import { MatTableDataSource } from "@angular/material/table";
import * as moment from "moment";
import { StateService } from "../../services/state.service";
@Component({
  selector: "cowing-core-backoffice-bookings",
  templateUrl: "./backoffice-bookings.component.html",
  styleUrls: ["./backoffice-bookings.component.scss"],
})
export class BackofficeBookingsComponent implements AfterViewInit, OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  resultsLength: any;
  public bookingStates = [];
  allSpaces: any = [];
  constructor(
    private _store: Store<IAppState>,
    private translate: TranslateService
  ) {}
  public displayedColumns: string[] = [];
  public dataSource = null;

  async ngOnInit() {
    // BackofficeService.instance.companyModified.subscribe((val) => {
    //   this.paginator.page.emit();
    // });
  }
  public async changeStatus(newStatus, companyId) {
    this._store.dispatch(showLoadingAction({}));
    try {
      const response = await BackofficeService.instance.changeBookingStatus(
        companyId,
        newStatus.value
      );
    } catch (e) {
      this._store.dispatch(
        showAlertAction({
          payload: {
            message: e.error,
            title: this.translate.instant("general.caution"),
            type: "error",
          },
        })
      );
    } finally {
      this.paginator.page.emit();
      this._store.dispatch(closeLoadingAction({}));
    }
  }

  public async changeDuration(newStatus, companyId) {
    // console.log(newStatus, companyId);
    // this._store.dispatch(showLoadingAction({}));
    // try {
    //   const response = await BackofficeService.instance.changeBookingStatus(
    //     companyId,
    //     newStatus.value
    //   );
    //   console.log(response);
    // } catch (e) {
    //   this._store.dispatch(
    //     showAlertAction({
    //       payload: {
    //         message: e.error,
    //         title: this.translate.instant("general.caution"),
    //         type: "error",
    //       },
    //     })
    //   );
    // } finally {
    //   this.paginator.page.emit();
    //   this._store.dispatch(closeLoadingAction({}));
    // }
  }

  async getAllSpaces() {
    try {
      const response = await BackofficeService.instance.getAllSpacesRaw();
      this.allSpaces = response;
    } catch (e) {
      this._store.dispatch(
        showAlertAction({
          payload: {
            message: e.error,
            title: this.translate.instant("general.caution"),
            type: "error",
          },
        })
      );
    }
  }
  async getBookingStates() {
    try {
      const response = await StateService.instance.getStates(1);
      console.log("Response of booking states", response);
      this.bookingStates = response;
    } catch (e) {
      this._store.dispatch(
        showAlertAction({
          payload: {
            message: e.error,
            title: this.translate.instant("general.caution"),
            type: "error",
          },
        })
      );
    }
  }
  private buildBooking(data) {
    return {
      id: data.id,
      start_date: data.start_date,
      end_date: data.end_date,
      start_time: data.start_time,
      end_time: data.end_time,
      private_price: data.private_price,
      public_price: data.public_price,
      duration_price_id: data.duration_price_id,
      space_id: data.space_id,
      user_id: data.user_id,
      coworker_email: data.coworker_email,
      coworking_id: data.coworking_id,
      coworking_name: data.coworking_name,
      state_id: data.state_id,
      created_at: data.created_at,
      updated_at: data.updated_at,
      company_name: data.company_name,
      company_id: data.company_id,
    };
  }

  getDurations(space_id) {
    const coincidence = this.allSpaces.find((space) => space.id == space_id);
    if (coincidence) {
      return coincidence.durations;
    } else return [];
  }

  async ngAfterViewInit() {
    this._store.dispatch(showLoadingAction({}));
    await this.getBookingStates();
    await this.getAllSpaces();
    this._store.dispatch(closeLoadingAction({}));
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this._store.dispatch(showLoadingAction({}));
          return BackofficeService.instance.getBookings({
            page: this.paginator.pageIndex,
            pageSize: this.paginator.pageSize,
          });
        }),
        map((data) => {
          this._store.dispatch(closeLoadingAction({}));
          this.resultsLength = data.total_elements;
          return data["bookings"];
        }),
        catchError((e) => {
          this._store.dispatch(
            showAlertAction({
              payload: {
                message: e.error,
                title: this.translate.instant("general.caution"),
                type: "error",
              },
            })
          );
          this._store.dispatch(closeLoadingAction({}));
          return observableOf([]);
        })
      )
      .subscribe((data) => {
        const dataFiltered = data.map((booking) => this.buildBooking(booking));
        if (!this.displayedColumns.length) {
          this.displayedColumns = Object.keys(dataFiltered[0]).filter(
            (val) => val !== "space_id"
          );

          this.displayedColumns.push("actions");
        }
        this.dataSource = new MatTableDataSource(dataFiltered);
      });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  public editBooking(company) {
    console.log(company);
    // this._store.dispatch(
    //   showAlertAction({
    //     payload: {
    //       message: null,
    //       title: null,
    //       type: "editCompany",
    //       editCompanyId: company.id,
    //     },
    //   })
    // );
  }

  dateToHours(date) {
    // return moment(date).format("HH:mm");
    return date.substr(0, 5);
  }

  dateFormated(date) {
    return moment(date).format("DD/MM/YYYY");
  }

  dateFormatedLong(date) {
    return moment(date).lang("es").format("DD/MM/YYYY HH:mm");
  }
  public deleteBooking(company) {
    console.log(company);
    // this._store.dispatch(
    //   showAlertAction({
    //     payload: {
    //       message: "",
    //       title: "Â¿Desea eliminar esta compaÃ±ia?",
    //       type: "deleteCompany",
    //       deleteCompanyId: company.id,
    //     },
    //   })
    // );
  }

  public get getEditIcon() {
    return `${iconsLibrary.editBackoffice}`;
  }
  public get getDeleteIcon() {
    return `${iconsLibrary.trashBackoffice}`;
  }
}
